import React, { useState, useRef } from 'react';

import getFormattedDate from '@stencil/flights-date-utils/src/get-formatted-date';
import formatPrice from '@ibibo/format-price';
import useOutsideClick from '@stencil/use-outside-click';

import Brownlock from '../../../icons/BrownLockIcon';
import Cross from '../../../icons/Cross';
import WhitelockIcon from '../../../icons/WhiteLockIcon';

import * as S from './price-lock-listing.styles';

const FarelockListing = ({
  details,
  fare,
  messageValues,
  bookPriceLock,
  getPriceLockInfoHtml,
  isLoggedIn,
  logPDT,
  hasMultipleFares = false
}) => {
  const [farlockOverlay, setFarelockOverlay] = useState(false);

  const modalRef = useRef();

  useOutsideClick(modalRef, () => {
    if (farlockOverlay) {
      setFarelockOverlay(false);
    }
  });

  const { v: validity, f: amount, e, tf: totalAmount, expiry, remainingAmount } = details;

  const overlayHandle = () => {
    logPDT({ action_name: hasMultipleFares ? 'pricelock_click_outer' : 'pricelock_click' });
    setFarelockOverlay(!farlockOverlay);
  };

  const html = getPriceLockInfoHtml(
    validity,
    formatPrice(amount),
    getFormattedDate(expiry, 'mmm dd, yyyy [h:MM TT]'),
    formatPrice(remainingAmount)
  );

  return (
    <>
      <S.FarelockListingOuter>
        <S.FarelockBtn className="justifyCenter alignItemsCenter" onClick={overlayHandle}>
          <div className="farelockTip">
            Click to lock price at <span className="go_blue fb">{formatPrice(amount)}</span> & book
            at the same price within <span className="go_blue fb">{validity} days</span> without any
            hike
          </div>
          <span className="btnText">
            {' '}
            <Brownlock width="1.1rem" height="1.4rem" /> <span className="marginL5">LOCK</span>
          </span>
        </S.FarelockBtn>

        {farlockOverlay && (
          <S.FarelockOverlay ref={modalRef}>
            <S.FarelockOveralayTop>
              <S.FarelockHead>Lock price</S.FarelockHead>
              <Cross onClick={overlayHandle} width="1.2rem" height="1.2rem" />
            </S.FarelockOveralayTop>
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
            {/* TODO: TnC link */}
            <p className="drGrey font14">
              View{' '}
              <a
                className="go_blue fb"
                href="https://www.goibibo.com/info/fare-lock-terms-and-conditions"
                target="_blank"
              >
                T&amp;Cs
              </a>
              .
            </p>
            <S.PaylockButton className="dF justifyCenter alignItemsCenter" onClick={bookPriceLock}>
              <WhitelockIcon width="1.2rem" height="1.6rem" loading="lazy" />{' '}
              <span className="marginL5">
                {isLoggedIn ? '' : 'Login and'} Pay {formatPrice(totalAmount)} to Lock
              </span>
            </S.PaylockButton>
          </S.FarelockOverlay>
        )}
      </S.FarelockListingOuter>
    </>
  );
};

export default FarelockListing;
